// import { decode } from "./enc";
import { isEmpty } from "lodash";

const parseToken = async (token) => {
  try {
    if (!token) {
      return { error: "token is invalid. token parsing failed" };
    }

    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var dataStr = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(dataStr);
  } catch (e) {
    return { error: "token is invalid. token parsing failed", errObject: e };
  }
};

export const setWithExpiry = async (key: string, value: any, ttl?: number) => {
  const now = new Date();

  if (!ttl) ttl = 24 * 60 * 60 * 1000; // 24 hours in miliseconds

  const parsedToken = await parseToken(value.refreshToken);

  console.log("token", now.getTime(), parsedToken.exp);
  if (parsedToken) {
    const item = {
      ...value,
      lastActive: now.getTime(),
      expireAt: parsedToken.exp * 1000, // refreshToken is in seconds
    };

    localStorage.setItem(key, JSON.stringify(item));
  }
};

export const getWithExpiry = (key: string) => {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return {};
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // is refresh token expired?
  if (now.getTime() > item.expireAt) {
    localStorage.removeItem(key);
    return {};
  }

  return item;
};

// Update last active timestamp on user interaction
document.addEventListener("mousemove", () => {
  const itemStr = localStorage.getItem("user");
  if (itemStr) {
    const item = JSON.parse(itemStr);
    item.lastActive = new Date().getTime();
    localStorage.setItem("user", JSON.stringify(item));
  }
});
